import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {MONTH_NAMES} from "../shared/dateTimeLists";

const ReportDate = () => {
    const d = new Date();
    let mo = MONTH_NAMES[(d.getMonth())];
    let hr = d.getHours();
    let ampm = 'am';
    if (hr > 12) {
        hr -= 12;
        ampm = 'pm';
    }
    let min = String('00' + d.getMinutes()).slice(-2);
    const str = mo + ' ' + d.getDate() + ', ' + d.getFullYear() + ', ' + hr + ':' + min + ' ' + ampm;
    return (
        <span>{str}</span>
    );
};

/**
 * Print Header Layout for Reports.
 *
 */
class ReportHeaderState extends Component {
    constructor(props) {
        super(props);
        this.state = {
            endDate: null,
            reportType: 'Report',
            startDate: null,
        };
    }

    componentWillMount() {
        this.setState({
            endDate: this.props.endDate,
            reportType: this.props.reportType,
            startDate: this.props.startDate,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.endDate !== this.props.endDate ||
            nextProps.reportType !== this.props.reportType ||
            nextProps.startDate !== this.props.startDate
        ) {
            this.setState({
                endDate: nextProps.endDate,
                reportType: nextProps.reportType,
                startDate: nextProps.startDate,
            });
        }
    }

    render() {

        const {
            endDate,
            reportType,
            startDate,
        } = this.state;

        const styles = {
            container: {
                display: 'none',
                width: '100%',
                margin: '0 0 2em 0',
            },
            logoContainer: {
                display: 'inline-block',
                width: '25%',
                verticalAlign: 'top',
            },
            logoImage: {
                width: '100%',
                height: 'auto',
            },
            headerContainer: {
                display: 'inline-block',
                width: '75%',
                color: '#333333',
                verticalAlign: 'top',
            },
            h1: {
                fontSize: '2em',
                fontWeight: 500,
                margin: '0 0 1em 0',
            },
            h2: {
                fontSize: '1.5em',
                fontWeight: 500,
                margin: '0 0 0.5em 0',
            },
            p: {
                fontSize: '1em',
                margin: '0 0 0.5em 0',
            },
        };
        return (
            <div>
                {startDate && endDate &&
                <div className="report-header" style={styles.container}>

                    {/* Header Column */}
                    <div style={styles.headerContainer}>
                        <div style={styles.h1}>{reportType}</div>
                        <div style={styles.p}>
                            Report Dates: <span className="bold">{<ReportDate/>}</span>
                        </div>
                    </div>

                    {/* Header Column: Logo */}
                    <div style={styles.logoContainer}>
                        <img src="CloudSent-POS-logo-admin.png" style={styles.logoImage} alt="CloudSent POS"/>
                    </div>
                </div>
                }
            </div>
        )
    }
}

ReportHeaderState.propTypes = {
    endDate: PropTypes.string,
    reportType: PropTypes.string,
    startDate: PropTypes.string,
};

ReportHeaderState.defaultProps = {
    endDate: null,
    reportType: 'Report',
    startDate: null,
};

export default ReportHeaderState;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportHeaderState.js